import style from "../chips/Chips.module.css";
const Chips = ({ type = "default", value = "", className=""}) => {

  const getColorByType = (type, value) => {
    const mappings = {
      contentType: {
        "Live Channel": "var(--chips-live-Channel)",
        Series: "var(--chips-series)",
        "Short Clip": "var(--chips-short-chip)",
        Movie: ` var(--chips-movie)`,
        Podcast: "var(--chips-podcast)",
        "Live Stream": "var(--chips-live-stream)",
        "Live Event": "var(--chips-live-stream)",
      },
      status: {
        "Save Draft": "var(--status-save-draft)",
        Rejected: "var(--status-rejected)",
        Published: "var(--status-approved)",
      },
      qcStatus: {
        Pending: "var(--qc-pending)",
        Approved: "var(--qc-approved)",
        Rejected: "var(--qc-rejected)",
      },
    };
    // "selected" chips (e.g. a picked genre/tag) aren't keyed by their
    // arbitrary label like the other types -- any value gets the same
    // accent-tint treatment.
    if (type === "selected") return "var(--accent-tint)";
    return mappings[type]?.[value] || "var(--status-NA)";
  };
  const chipStyle = {
    backgroundColor: getColorByType(type, value),
  };
  const combinedClassName =
    `${style.Chip} ${className}`

  return (
    <div className={combinedClassName} style={chipStyle}>
      {value}
    </div>
  );
};
export default Chips;
